import { render } from "./RegistroLecheAcopio.vue?vue&type=template&id=0273c206"
import script from "./RegistroLecheAcopio.vue?vue&type=script&lang=js"
export * from "./RegistroLecheAcopio.vue?vue&type=script&lang=js"

import "./RegistroLecheAcopio.vue?vue&type=style&index=0&id=0273c206&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__